/**
 * Dashboard stats query hook (PATTERNS.md TanStack Query pattern).
 *
 * Polls every 60s (D-11), refetches on window focus.
 * Uses queryKeys.dashboard.stats for consistent cache key.
 */
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../lib/query-keys';
import { fetchDashboardStats } from '../api/dashboard';

export function useDashboardStats() {
  return useQuery({
    queryKey: queryKeys.dashboard.stats,
    queryFn: fetchDashboardStats,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });
}
